export default __webpack_public_path__ + "static/media/phone.9a678eae.jpg";